// Busca uma foto de referência na internet (Wikimedia Commons, sem precisar de
// chave de API) a partir do nome digitado pro material. Como o acervo é
// majoritariamente em inglês, traduz os termos de artesanato/hardware mais
// comuns antes de buscar — sem tradução reconhecida, busca o nome como veio.
const TERMOS_PT_EN = [
  [/im[ãa]\b/i, "magnet"],
  [/argolinha|argola/i, "jump ring jewelry"],
  [/cola\s*quente/i, "glue stick"],
  [/fita\s*dupla\s*face/i, "double sided tape"],
  [/mosquet[ãa]o/i, "lobster clasp"],
  [/corrente/i, "chain jewelry"],
  [/el[áa]stico/i, "rubber band"],
  [/parafuso/i, "screw"],
  [/arruela/i, "washer hardware"],
  [/^led\b|\bled\b/i, "led diode"],
  [/pilha|bateria/i, "AA battery"],
  [/tinta\s*spray/i, "spray paint can"],
  [/verniz/i, "varnish can"],
  [/resina/i, "epoxy resin"],
  [/veludo/i, "velvet fabric"],
  [/fecho/i, "clasp hardware"],
  [/barbante|cord[ãa]o/i, "twine string"],
  [/chaveiro/i, "keychain"],
  [/strass/i, "rhinestone"],
  [/mi[çc]angas?/i, "beads craft"],
  [/feltro/i, "felt fabric"],
  [/tecido/i, "fabric cloth"],
  [/lantejoula/i, "sequin"],
  [/adesivo/i, "sticker"],
  [/etiqueta/i, "label tag"],
];

function termoBusca(nome) {
  const n = (nome || "").trim();
  if (!n) return null;
  for (const [re, termo] of TERMOS_PT_EN) if (re.test(n)) return termo;
  return n;
}

// "geograph.org.uk" é um acervo de fotos de paisagens do Reino Unido que
// domina o full-text search do Commons pra várias palavras comuns em inglês
// (ex.: "ring", "screw") sem nenhuma relação com o objeto procurado.
function paginaValida(p) {
  const titulo = p?.title || "";
  if (!/\.(jpe?g|png|gif)$/i.test(titulo)) return false;
  if (/geograph\.org\.uk/i.test(titulo)) return false;
  return true;
}

async function buscarCommons(gsrsearch) {
  const url = "https://commons.wikimedia.org/w/api.php?" + new URLSearchParams({
    action: "query", format: "json", origin: "*",
    generator: "search", gsrnamespace: "6", gsrsearch, gsrlimit: "10",
    prop: "imageinfo", iiprop: "url", iiurlwidth: "320",
  });
  const res = await fetch(url);
  if (!res.ok) return null;
  const data = await res.json();
  if (!data?.query?.pages) return null;
  // Object.values() reordena chaves numéricas (pageid) — precisa reordenar
  // pelo campo "index" pra respeitar a ordem de relevância da busca.
  const paginas = Object.values(data.query.pages).sort((a,b) => (a.index||0) - (b.index||0));
  const foto = paginas.find(paginaValida);
  return foto?.imageinfo?.[0]?.thumburl || null;
}

// Retorna a URL de uma foto (thumbnail https, ~300px) ou null se não achar nada.
// Busca em duas etapas: primeiro só em arquivos com a frase exata no título
// (bem mais preciso), e só se não achar nada cai pro texto livre (mais
// resultados, porém mais ruído).
export async function buscarFotoMaterial(nome) {
  const termo = termoBusca(nome);
  if (!termo) return null;
  try {
    const precisa = await buscarCommons(`intitle:"${termo}"`);
    if (precisa) return precisa;
    return await buscarCommons(termo);
  } catch {
    return null;
  }
}
